import React from "react"
import PropTypes from "prop-types"

import {ErrorMessage } from "../styled"

export const TextInput = ({
  field,
  form: {errors},
  ...props
}) => {
  return (
    <>
      <input type={props.type} {...field} {...props} className="form-control" placeholder={props.placeholder} disabled={props.disabled} />
      {errors[field.name] && <ErrorMessage>{errors[field.name]}</ErrorMessage>}
    </>
  )
}

TextInput.propTypes = {
  field: PropTypes.object,
  form: PropTypes.object,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  disabled: PropTypes.bool
}
